import { track } from "@amplitude/analytics-react-native";
import { useCallback } from "react";
import { amp } from "src/api/amplitude";
import ReportEntityDocument from "src/api/graphql/__generated__/documents/ReportEntityDocument";
import EntityType from "src/api/graphql/__generated__/enums/EntityType";
import { useAsyncMutation } from "src/api/graphql/helper";
import Touchable from "src/components/Touchable";
import log from "src/helpers/log";
import IconFlag from "src/icons/IconFlag";
import { prompt } from "src/swsh-native";
import toast from "src/swsh-native/toast";

const GatheringPublicReport = ({ gatheringId }: { gatheringId: string }) => {
	const publicReport = useAsyncMutation(ReportEntityDocument);
	const handleReport = useCallback(() => {
		try {
			track(amp.gathering.previewReport.initiate, {
				gatheringId,
			});
			prompt({
				title: "Report",
				message:
					"Please tell us why you are reporting this album. Your message is reported directly to swsh.",
				buttons: [
					{
						style: "destructive",
						text: "Report",
						onPress: async (reason) => {
							track(amp.gathering.previewReport.confirm, {
								gatheringId,
							});
							await publicReport({
								input: {
									entityId: gatheringId,
									entityType: EntityType.Gathering,
									reason,
								},
							});
							toast({
								preset: "done",
								title: "Album reported",
								message: "Thank you for your report",
							});
						},
					},
					{
						style: "cancel",
						text: "Cancel",
						onPress: () => {
							track(amp.gathering.previewReport.cancel, {
								gatheringId,
							});
						},
					},
				],
			});
		} catch (err) {
			log.error({ err }, "Error in handleReport");
			toast({
				preset: "error",
				title: "Something went wrong",
				message: "Please try again later",
			});
		}
	}, [gatheringId, publicReport]);

	return (
		<Touchable onPress={handleReport}>
			<IconFlag size={22} />
		</Touchable>
	);
};
export default GatheringPublicReport;
